import { useLanguage, LANGUAGES } from './useLanguage';
import fr from '../i18n/fr.json';
import en from '../i18n/en.json';

const translations: Record<LANGUAGES, Record<string, string>> = {
    [LANGUAGES.FRENCH]: fr,
    [LANGUAGES.ENGLISH]: en,
};

export const useTranslation = () => {
    const { language } = useLanguage();

    const t = (key: string): string => {
        return translations[language][key] ?? key;
    };

    return { t };
};
